<div class="push-notification-modal">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-title-notification">Push Notification</h6>
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>
  <div class="modal-body">
    <form
      [formGroup]="pushNotificationForm"
      (ngSubmit)="onPushNotificationSubmit()"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="form-control-label" for="notification-title">
              Notification Title
            </label>
            <input
              type="text"
              id="notification-title"
              class="form-control"
              formControlName="notificationTitle"
            />
            <div
              *ngIf="
                (isSubmited ||
                  pushNotificationForm.controls.notificationTitle.dirty) &&
                pushNotificationForm.controls.notificationTitle.errors
              "
              class="input-errors"
            >
              <p
                *ngIf="
                  pushNotificationForm.controls.notificationTitle.errors
                    .required
                "
              >
                This field is required!
              </p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="form-control-label" for="notification-message">
              Notification Message
            </label>
            <input
              type="text"
              id="notification-message"
              class="form-control"
              formControlName="notificationMessage"
            />
            <div
              *ngIf="
                (isSubmited ||
                  pushNotificationForm.controls.notificationMessage.dirty) &&
                pushNotificationForm.controls.notificationMessage.errors
              "
              class="input-errors"
            >
              <p
                *ngIf="
                  pushNotificationForm.controls.notificationTitle.errors
                    .required
                "
              >
                This field is required!
              </p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <button
            class="btn btn-block btn-primary"
            type="submit"
            [disabled]="pushNotificationForm.invalid"
          >
            Push Notification
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
